import { axiosPut } from '@/api/AxiosApi';
import { sendRequest, EndpointPayload } from '@/api/AxiosRequest';
import { UpdateStakeDbPoolRequest, UpdateStakeDbPoolStateRequest } from '@/types/stake-db';

const BALANCE_API_URL = process.env.REACT_APP_BALANCE_API_URL;

// 풀 정보 수정
export const updateStakeDbPool = async (data: UpdateStakeDbPoolRequest) => {
  const { poolId, ...bodyWithoutPoolId } = data;
  const payload: EndpointPayload = {
    path: `/assetfi/admin/staking/pools/${poolId}`,
    body: bodyWithoutPoolId,
    apiUrl: BALANCE_API_URL,
    skipConvert: true,
  };

  return await sendRequest(payload, 'updateStakeDbPool', axiosPut);
};

// 풀 상태 변경
export const updateStakeDbPoolState = async (data: UpdateStakeDbPoolStateRequest) => {
  const payload: EndpointPayload = {
    path: '/assetfi/admin/staking/pools/state',
    body: data,
    apiUrl: BALANCE_API_URL,
    skipConvert: true,
  };

  return await sendRequest(payload, 'updateStakeDbPoolState', axiosPut);
};
